var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1139,
    height: 1139,
    viewBox: "0 0 1139 1139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.5 0C883.934 0 1139 254.946 1139 569.5C1139 884.054 884.054 1139 569.5 1139C254.946 1139 0 883.934 0 569.5C0 255.066 254.946 0 569.5 0Z",
    fill: "url(#paint0_linear_3809_84381)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.735 864.192C905.356 864.192 1089.44 679.984 1089.44 454.482C1089.44 228.98 905.356 44.2939 679.735 44.2939C454.113 44.2939 269.666 228.382 269.666 454.363C269.666 680.343 453.874 864.072 679.735 864.072V864.192Z",
    fill: "url(#paint1_linear_3809_84381)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.043 1094.72C684.665 1094.72 868.753 910.51 868.753 685.008C868.753 459.506 684.545 274.819 459.043 274.819C233.541 274.819 49.2139 459.027 49.2139 684.888C49.2139 910.749 233.063 1094.6 458.923 1094.6L459.043 1094.72Z",
    fill: "url(#paint2_linear_3809_84381)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.14 274.819C401.448 274.819 346.509 286.908 296.597 308.573C279.241 353.937 269.666 403.011 269.666 454.359C269.666 679.981 453.874 864.069 679.735 864.069C737.307 864.069 792.127 851.98 841.919 830.435C859.274 785.191 868.85 736.117 868.85 684.888C868.85 458.907 684.642 274.819 459.14 274.819Z",
    fill: "#0D398F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.658 820.61C707.783 820.61 820.774 707.619 820.774 569.493C820.774 431.368 707.783 318.736 569.658 318.736C431.532 318.736 318.9 431.368 318.9 569.493C318.9 707.619 431.532 820.61 569.658 820.61Z",
    fill: "url(#paint3_radial_3809_84381)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3809_84381",
    x1: 546.04,
    y1: 508.217,
    x2: 371.647,
    y2: 53.2634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00359A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3809_84381",
    x1: 275.531,
    y1: 454.243,
    x2: 1095.43,
    y2: 454.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#073E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#073E99",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#073E99",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#073E99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#FF6900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3809_84381",
    x1: 868.753,
    y1: 684.768,
    x2: 49.2139,
    y2: 684.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#073E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#073E99",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#073E99",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#073E99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3809_84381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(525.85 486.546) scale(250.877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0048A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013B9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.95146d905cb16250455f863ccbc1ec39.svg";
export { ForwardRef as ReactComponent };